export default __webpack_public_path__ + "static/media/ogc-hero-stock-steps-dark.f14541f3.jpg";